"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibZipImpl = exports.JsZipImpl = void 0;
exports.getLibzipSync = getLibzipSync;
exports.getLibzipPromise = getLibzipPromise;
const tslib_1 = require("tslib");
const instance_1 = require("./instance");
const libzipSync_1 = tslib_1.__importDefault(require("./libzipSync"));
const makeInterface_1 = require("./makeInterface");
tslib_1.__exportStar(require("./common"), exports);
(0, instance_1.setFactory)(() => {
    const emZip = (0, libzipSync_1.default)();
    return (0, makeInterface_1.makeInterface)(emZip);
});
function getLibzipSync() {
    return (0, instance_1.getInstance)();
}
async function getLibzipPromise() {
    return (0, instance_1.getInstance)();
}
var jsZipImpl_1 = require("./jsZipImpl");
Object.defineProperty(exports, "JsZipImpl", { enumerable: true, get: function () { return jsZipImpl_1.JsZipImpl; } });
var libzipImpl_1 = require("./libzipImpl");
Object.defineProperty(exports, "LibZipImpl", { enumerable: true, get: function () { return libzipImpl_1.LibZipImpl; } });
